import { useMutation } from '@tanstack/react-query';
import { SwitchInlineEditor } from 'components/inline_edit/ToggleInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

export function LocationAutoMaintenanceCell({
    rowData,
    onChange,
}: LocationsTableCellProps) {
    const { canViewIntegrations } = usePermissions();
    const { showToast } = useNotificationContext();
    const { mutate: setLocationAutomaticMaintenance, isPending } = useMutation({
        mutationFn: (status: boolean) =>
            updateLocation(rowData, { AutoCreateMaintenanceTask: status }),

        onSuccess: () => {
            showToast({
                type: 'success',
                content:
                    'Successfully updated automatic maintenance task creation status',
            });
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save automatic maintenance task creation status',
            }),
    });

    return (
        <SwitchInlineEditor
            value={rowData.AutoCreateMaintenanceTask}
            onConfirm={(val) => setLocationAutomaticMaintenance(val ?? false)}
            isDisabled={isPending || !canViewIntegrations}
            renderValue={(val) => (val ? 'Yes' : 'No')}
        />
    );
}
